import {
  useEffect, useCallback, useState, useMemo, useRef,
} from 'react';
// import { useSelector } from 'react-redux';
// import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import devicesApi from '@api/devicesApi';
import requestHelpers from '@utils/helpers/forRequest';
import moment from 'moment';

import getColumnsLogs from './getColumnsLogs';

function useDispositivos_Logs() {

  const { t } = useTranslation();
  // const clientTarget = useSelector(({ user: u }) => u.clientTarget);

  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const paginationRef = useRef({ current: 1, pageSize: 100 });
  const tableFiltersRef = useRef({});
  const othersFiltersRef = useRef({});

  const columns = useMemo(() => getColumnsLogs({ setSelectedItem, t }), [t]);

  const makeRequest = useCallback(() => {

    const { current, pageSize: limit } = paginationRef.current;
    const offset = (current - 1) * limit;
    const filters = { ...tableFiltersRef.current, ...othersFiltersRef.current };

    setLoading(true);
    devicesApi
      .getLogs({
        offset, limit, ...filters,
      })
      .then((response) => {

        const total = response.length;
        const results = response.map((values) => {

          const data = {
            device: values.device,
            date: values.time,
            resetStatus: values.content.reset_status,
            systemStatus: values.content.system_status,
            bits: values.bits_status,
          };
          return data;

        });
        paginationRef.current = { ...paginationRef.current, total };
        setDataSource(results);
        setLoading(false);

      })
      .catch((resError) => {

        const { fem } = resError;
        // eslint-disable-next-line no-console
        console.log(t(fem));
        setLoading(false);

      });

  }, [t]);

  const onChangeRangeDates = useCallback(
    (dates) => {

      const [start_date, end_date] = dates
        ? dates.map(requestHelpers.getDateFormatForRequest)
        : [undefined, undefined];
      othersFiltersRef.current = { ...othersFiltersRef.current, start_date, end_date };

      paginationRef.current = { ...paginationRef.current, current: 1 };
      if (start_date && end_date) makeRequest();

    },
    // eslint-disable-next-line
    []
  );

  const handleTableChange = useCallback(
    (pagination, filters, sorter) => {

      const mapFilter = filters
        ? Object.entries(filters).reduce((acc, cur) => {

          const [key, value] = cur;
          if (!value) return acc;
          acc[key] = value.join(',');
          return acc;

        }, {})
        : undefined;

      paginationRef.current = { ...paginationRef.current, ...pagination };
      tableFiltersRef.current = mapFilter;

      makeRequest();

    },
    // eslint-disable-next-line
    []
  );

  const onSearch = useCallback((device) => {

    if (!device) {

      const newOthersFiltersRef = { ...othersFiltersRef.current };
      if (newOthersFiltersRef?.search) delete newOthersFiltersRef.search;
      othersFiltersRef.current = newOthersFiltersRef;

    } else {

      othersFiltersRef.current = { ...othersFiltersRef.current, search: device };

    }

    paginationRef.current = { ...paginationRef.current, current: 1 };
    makeRequest();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {

    const start_date = moment().subtract(7, 'days').utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');
    const end_date = moment().utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss');

    othersFiltersRef.current = {
      ...othersFiltersRef.current,
      start_date,
      end_date,
    };

    handleTableChange(paginationRef.current);
    // eslint-disable-next-line
  }, []);

  return {
    loading,
    columns,
    dataSource,
    selectedItem,
    setSelectedItem,
    pagination: paginationRef.current,
    handleTableChange,
    onChangeRangeDates,
    onSearch,
  };

}

export default useDispositivos_Logs;
